import styled from "styled-components";
import { Select, Table, TreeSelect, Radio } from "antd";


export const FilterSelector = styled(Select)`
  & .ant-select-selector {
    height: 2.25rem;
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    border-radius: 9999px !important;
  }

  /* Keep placeholder vertically centered in multiple mode (Franchise filter). */
  &.ant-select-multiple .ant-select-selection-placeholder {
    inset-block-start: 50%;
    transform: translateY(-50%);
  }

  /* Franchise selector: keep selected tags vertically centered and slightly shifted right. */
  &.franchise-selector.ant-select-multiple .ant-select-selector {
    padding-inline-start: 0.5rem;
  }

  &.franchise-selector.ant-select-multiple .ant-select-selection-overflow {
    min-height: calc(2.25rem - 2px);
    align-items: center;
  }

  &.franchise-selector.ant-select-multiple .ant-select-selection-overflow-item {
    display: flex;
    align-items: center;
  }

  /* When "All Franchises" is active, show placeholder in black (not grey). */
  &.franchise-all-selected .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.88) !important;
  }
`;

export const FilterTreeSelector = styled(TreeSelect)`
  /* Rules are scoped with & and target antd's own class names directly,
   * rather than the wrapper nesting around them. That keeps the selectors
   * short and stops an antd version bump from breaking them.
  */
  height: 2.25rem;
  display: flex;
  align-items: center;
  & .ant-select-selector {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 0.75rem;
    padding-block: 0;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
  }
  & .ant-select-selection-item {
    /* height: 24px; */

    display: flex;
    align-items: center;

    /* Reset line-height so it cannot fight the flex centering above. */
    line-height: normal;
    margin-block: 6px;
  }
  & .ant-select-multiple .ant-select-selection-overflow-item-suffix {
    margin-block: 0;
  }
  & .ant-select-selection-overflow {
    height: calc(2.25rem - 2px);
    display: flex;
    align-items: center;
  }
  & .ant-select-selection-wrap {
    display: block;
    height: calc(2.25rem - 2px);
  }

  & .ant-select-selection-item-content {
    padding-right: 4px;
  }
  & .ant-select-outlined {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
`;

export const MarketOverviewTable = styled(Table)`
  & .ant-table {
    font-family: "Inter", sans-serif;
  }
  & .ant-table-thead > tr > th {
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    padding: 0.63rem;
    height: 3.8rem;
    vertical-align: middle;
    color: #27272a;
  }
  & .ant-table-tbody {
    font-family: "Inter", sans-serif;
    font-size: 0.85rem;
    font-weight: 400;
    padding: 0.625rem;
  }
  & .ant-table-tbody > tr > td {
    font-family: "Inter", sans-serif;
  }
  & .ant-table.ant-table-bordered > .ant-table-container {
    border-top: 0.5px solid #f0f0f0;
    border-inline-start: 0.5px solid #f0f0f0;
    /* border-inline-end: 0.5px solid #f0f0f0; */
    box-shadow: none;
  }
  & .ant-table-cell {
    height: 2.5rem;
    /* border-top: 0.5px solid #f0f0f0; */
    border-bottom: 0.5px solid #f0f0f0 !important;
    /* border-inline-start: 0.5px solid #f0f0f0 !important; */
    border-inline-end: 0.5px solid #f0f0f0 !important;
  }
`;

export const CustomRadio = styled(Radio)`
  & .ant-radio-checked .ant-radio-inner::after {
    background-color: #0e49b5;
  }
  & .ant-radio-checked .ant-radio-inner {
    background-color: #fff;
    border-width: 1.5px;
    width: 16px;
    height: 16px;
  }
  & .ant-radio-inner::after {
    width: 20px;
    height: 20px;
    inset-inline-start: 33%;
    inset-block-start: 33%;
  }
`;
